export default __webpack_public_path__ + "static/90-anniversary-logo-c887c63c3338368fd02079f23ba0a722.png";